import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_notifications.png'


const _withScopeId = n => (_pushScopeId("data-v-6d18c15a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view notifications" }
const _hoisted_2 = {
  key: 0,
  class: "notifications__text"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "notifications__decor",
  src: _imports_0
}, null, -1))

import { Ref, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Message, MessagesService } from '@/services/MessagesService';
import BaseBackLink from '@/components/shared/BaseBackLink.vue';
import BaseNotificationCard from '@/components/notifications/BaseNotificationCard.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsView',
  setup(__props) {

const router = useRouter();

const messages: Ref<null | Message[]> = ref(null);
onBeforeMount(async () => {
	// Get messages
	MessagesService.getMessages().then(
		(_messages) =>
			(messages.value = Array.isArray(_messages.messages)
				? _messages.messages
				: [])
	);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseBackLink, {
      onClick: _unref(router).back
    }, {
      default: _withCtx(() => [
        _createTextVNode("Уведомления")
      ]),
      _: 1
    }, 8, ["onClick"]),
    (messages.value !== null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
            return (_openBlock(), _createBlock(BaseNotificationCard, {
              key: message.guid,
              title: "Уведомление",
              text: message.message
            }, null, 8, ["text"]))
          }), 128)),
          (messages.value.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, " У вас пока нет никаких уведомлений "))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(BaseLoader, {
          key: 1,
          size: "md"
        })),
    _hoisted_3
  ]))
}
}

})